import { HTMLAttributes, ReactNode } from 'react';
import { cn } from 'src/shared/lib/utils';

type SubtleCapsHeadersProps = {
  children: ReactNode;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export default function SubtleCapsHeaders({ children, className, ...props }: SubtleCapsHeadersProps) {
  return (
    <div
      className={cn(
        'text-typography-grey text-xs leading-none tracking-widest font-medium uppercase pt-[1px] flex items-center',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
